export enum CaseFilterGroup {
  main = "main",
  quickFilter = "quickFilter",
  byPriority = "byPriority",
  byView = "byView",
  byDate = "byDate",
}
